module.exports = __webpack_public_path__ + "static/video-d1e8dcf9a0140a811b0832e025a2644e.png";